"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VotingStrategyType = exports.ProposingStrategyType = exports.GovPowerStrategyType = exports.RoundEventState = exports.RoundType = exports.Infinite = exports.Timed = exports.HouseType = exports.AccountField = exports.AssetType = void 0;
//#endregion
//#region Assets
var AssetType;
(function (AssetType) {
    AssetType[AssetType["ETH"] = 0] = "ETH";
    AssetType[AssetType["ERC20"] = 1] = "ERC20";
    AssetType[AssetType["ERC721"] = 2] = "ERC721";
    AssetType[AssetType["ERC1155"] = 3] = "ERC1155";
})(AssetType || (exports.AssetType = AssetType = {}));
//#endregion
//#region Storage Proofs
var AccountField;
(function (AccountField) {
    AccountField[AccountField["StorageHash"] = 0] = "StorageHash";
    AccountField[AccountField["CodeHash"] = 1] = "CodeHash";
    AccountField[AccountField["Balance"] = 2] = "Balance";
    AccountField[AccountField["Nonce"] = 3] = "Nonce";
})(AccountField || (exports.AccountField = AccountField = {}));
//#endregion
//#region Houses
var HouseType;
(function (HouseType) {
    HouseType["COMMUNITY"] = "COMMUNITY";
})(HouseType || (exports.HouseType = HouseType = {}));
//#endregion
//#region Timed Round
var Timed;
(function (Timed) {
    let RoundState;
    (function (RoundState) {
        RoundState[RoundState["UNKNOWN"] = 0] = "UNKNOWN";
        RoundState[RoundState["CANCELLED"] = 1] = "CANCELLED";
        RoundState[RoundState["NOT_STARTED"] = 2] = "NOT_STARTED";
        RoundState[RoundState["IN_PROPOSING_PERIOD"] = 3] = "IN_PROPOSING_PERIOD";
        RoundState[RoundState["IN_VOTING_PERIOD"] = 4] = "IN_VOTING_PERIOD";
        RoundState[RoundState["IN_REPORTING_PERIOD"] = 5] = "IN_REPORTING_PERIOD";
        RoundState[RoundState["IN_CLAIMING_PERIOD"] = 6] = "IN_CLAIMING_PERIOD";
        RoundState[RoundState["COMPLETE"] = 7] = "COMPLETE";
    })(RoundState = Timed.RoundState || (Timed.RoundState = {}));
    let Action;
    (function (Action) {
        Action["PROPOSE"] = "PROPOSE";
        Action["EDIT_PROPOSAL"] = "EDIT_PROPOSAL";
        Action["CANCEL_PROPOSAL"] = "CANCEL_PROPOSAL";
        Action["VOTE"] = "VOTE";
    })(Action = Timed.Action || (Timed.Action = {}));
})(Timed || (exports.Timed = Timed = {}));
//#endregion
//#region Infinite Round
var Infinite;
(function (Infinite) {
    let RoundState;
    (function (RoundState) {
        RoundState[RoundState["UNKNOWN"] = 0] = "UNKNOWN";
        RoundState[RoundState["CANCELLED"] = 1] = "CANCELLED";
        RoundState[RoundState["NOT_STARTED"] = 2] = "NOT_STARTED";
        RoundState[RoundState["ACTIVE"] = 3] = "ACTIVE";
        RoundState[RoundState["COMPLETE"] = 4] = "COMPLETE";
    })(RoundState = Infinite.RoundState || (Infinite.RoundState = {}));
    let Direction;
    (function (Direction) {
        Direction[Direction["AGAINST"] = 0] = "AGAINST";
        Direction[Direction["FOR"] = 1] = "FOR";
    })(Direction = Infinite.Direction || (Infinite.Direction = {}));
    let Action;
    (function (Action) {
        Action["PROPOSE"] = "PROPOSE";
        Action["VOTE"] = "VOTE";
    })(Action = Infinite.Action || (Infinite.Action = {}));
})(Infinite || (exports.Infinite = Infinite = {}));
//#endregion
//#region Round
var RoundType;
(function (RoundType) {
    RoundType["INFINITE"] = "INFINITE";
    RoundType["TIMED"] = "TIMED";
})(RoundType || (exports.RoundType = RoundType = {}));
var RoundEventState;
(function (RoundEventState) {
    RoundEventState["CREATED"] = "CREATED";
    RoundEventState["FINALIZED"] = "FINALIZED";
    RoundEventState["CANCELLED"] = "CANCELLED";
})(RoundEventState || (exports.RoundEventState = RoundEventState = {}));
var GovPowerStrategyType;
(function (GovPowerStrategyType) {
    GovPowerStrategyType["BALANCE_OF_ERC1155"] = "BALANCE_OF_ERC1155";
    GovPowerStrategyType["BALANCE_OF_ERC20"] = "BALANCE_OF_ERC20";
    GovPowerStrategyType["BALANCE_OF"] = "BALANCE_OF";
    GovPowerStrategyType["CHECKPOINTABLE_ERC721"] = "CHECKPOINTABLE_ERC721";
    GovPowerStrategyType["ALLOWLIST"] = "ALLOWLIST";
    GovPowerStrategyType["VANILLA"] = "VANILLA";
    GovPowerStrategyType["UNKNOWN"] = "UNKNOWN";
})(GovPowerStrategyType || (exports.GovPowerStrategyType = GovPowerStrategyType = {}));
exports.ProposingStrategyType = GovPowerStrategyType;
exports.VotingStrategyType = GovPowerStrategyType;
//#endregion
